import React from 'react';

interface Props {
  className?: string;
}

const Path: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 176">
      <path
        d="M4 12.5L20 12.5"
        id="Vector 29"
        stroke="currentColor"
        strokeDasharray="2 2"
        strokeWidth="3"
      />
    </g>
  </svg>
);

export default Path;
